import { Button } from '@vadiun/react-components';
import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import useChoferes from 'app/chofer/services/ChoferService';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { useRef, useState } from 'react';
import { DriverExpirationTable } from '../components/DriverExpirationTable';
import { useDriverExpirationRepository } from '../services/DriverExpirationRepository';
import { createTableScrollHandler } from 'utils/tableUtils';

export const DriverExpirationPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const driverRepo = useChoferes();
  const driversQuery = useSuperQuery(driverRepo.getChoferes);
  const [showFilters, setShowFilters] = useState(false);
  const driverExpirationRepo = useDriverExpirationRepository();
  const driverExpirationQuery = useSuperQuery(
    () => driverExpirationRepo.getExpirations(),
    { showSpinner: true }
  );

  return (
    <div ref={tableRef}>
      <PageHeader
        area="Operaciones - G.D.F."
        title="Vencimientos Flota"
        toolbar={
          <Button variant="light" onClick={() => setShowFilters(true)}>
            Filtros
          </Button>
        }
      />
      <PageContainer>
        <DriverExpirationTable tableProps={driverExpirationQuery.data ?? []}  handlePageChange={createTableScrollHandler(tableRef)}/>
      </PageContainer>
    </div>
  );
};
